export type CommunityTypes = "COMMUNITY" | "ASSOCIATION" | "ORGANISATION";
export type CommunityTab = "all" & CommunityTypes;

export const handleTabColors = (tab: CommunityTab, isActive: boolean) => {
  switch (tab) {
    case "all":
      return isActive ? "defaultActiveText" : "defaultTab hover:allText";
    case "COMMUNITY":
      return isActive ? "communityText" : `defaultTab hover:communityText`;
    case "ASSOCIATION":
      return isActive ? "associationText" : `defaultTab hover:associationText`;
    case "ORGANISATION":
      return isActive
        ? "organisationText"
        : `defaultTab hover:organisationText`;
    default:
      return "";
  }
};

export const handleCommunityTextColors = (tab: CommunityTypes) => {
  switch (tab) {
    case "COMMUNITY":
      return "communityText";
    case "ASSOCIATION":
      return "associationText";
    case "ORGANISATION":
      return "organisationText";
    default:
      return "";
  }
};

export const handleCommunityDotColors = (tab: CommunityTypes) => {
  switch (tab) {
    case "COMMUNITY":
      return "communityBg";
    case "ASSOCIATION":
      return "associationBg";
    case "ORGANISATION":
      return "organisationBg";
    default:
      return "";
  }
};
